// extracted by mini-css-extract-plugin
export default {"formSection":"trainer-tip-form_formSection__Grh6T"};